import { motion } from "framer-motion";

// 1. Clear
const AnimatedSun = () => (
  <motion.svg
    className="w-5 h-5 text-yellow-400 drop-shadow-md"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <motion.g
      animate={{ rotate: 360 }}
      transition={{ duration: 12, repeat: Infinity, ease: "linear" }}
      style={{ originX: "50%", originY: "50%" }}
    >
      <circle cx="12" cy="12" r="4" strokeWidth="2" fill="#FACC15" />
      <path
        strokeWidth="2"
        strokeLinecap="round"
        d="M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32l1.41 1.41M2 12h2m16 0h2M4.93 19.07l1.41-1.41m11.32-11.32l1.41-1.41"
      />
    </motion.g>
  </motion.svg>
);

// 2. Mostly Clear
const AnimatedMostlyClear = () => (
  <div className="relative w-5 h-5">
    <motion.svg
      className="absolute inset-0 text-yellow-400"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <motion.g
        animate={{ rotate: 360 }}
        transition={{ duration: 12, repeat: Infinity, ease: "linear" }}
        style={{ originX: "50%", originY: "50%" }}
      >
        <circle cx="12" cy="12" r="4" strokeWidth="2" fill="#FACC15" />
        <path
          strokeWidth="2"
          strokeLinecap="round"
          d="M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32l1.41 1.41M2 12h2m16 0h2M4.93 19.07l1.41-1.41m11.32-11.32l1.41-1.41"
        />
      </motion.g>
    </motion.svg>
    <motion.svg
      className="absolute right-0 bottom-0 w-2.5 h-2.5 text-gray-200 drop-shadow-sm mt-2.5 ml-2.5"
      fill="currentColor"
      viewBox="0 0 24 24"
      animate={{ x: [-1, 1, -1] }}
      transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
    >
      <path d="M6.5 17.5a4.5 4.5 0 01-1.23-8.83 7 7 0 1113.46 0 4.5 4.5 0 01-1.23 8.83H6.5z" />
    </motion.svg>
  </div>
);

// 3. Partly Cloudy
const AnimatedPartlyCloudy = () => (
  <div className="relative w-5 h-5">
    <motion.svg
      className="absolute inset-0 text-yellow-400 -mt-1 -mr-1 scale-90"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <motion.g
        animate={{ rotate: 360 }}
        transition={{ duration: 12, repeat: Infinity, ease: "linear" }}
        style={{ originX: "50%", originY: "50%" }}
      >
        <circle cx="12" cy="12" r="4" strokeWidth="2" fill="#FACC15" />
        <path
          strokeWidth="2"
          strokeLinecap="round"
          d="M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32l1.41 1.41M2 12h2m16 0h2M4.93 19.07l1.41-1.41m11.32-11.32l1.41-1.41"
        />
      </motion.g>
    </motion.svg>
    <motion.svg
      className="absolute inset-0 text-gray-200 drop-shadow-md mt-1"
      fill="currentColor"
      viewBox="0 0 24 24"
      animate={{ x: [-1, 1, -1] }}
      transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
    >
      <path d="M6.5 17.5a4.5 4.5 0 01-1.23-8.83 7 7 0 1113.46 0 4.5 4.5 0 01-1.23 8.83H6.5z" />
    </motion.svg>
  </div>
);

// 4. Mostly Cloudy
const AnimatedMostlyCloudy = () => (
  <div className="relative w-5 h-5">
    <motion.svg
      className="absolute inset-0 text-yellow-400 -ml-2 -mt-2 scale-75 opacity-80"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <motion.g
        animate={{ rotate: 360 }}
        transition={{ duration: 12, repeat: Infinity, ease: "linear" }}
        style={{ originX: "50%", originY: "50%" }}
      >
        <circle cx="12" cy="12" r="4" strokeWidth="2" fill="#FACC15" />
        <path
          strokeWidth="2"
          strokeLinecap="round"
          d="M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32l1.41 1.41M2 12h2m16 0h2M4.93 19.07l1.41-1.41m11.32-11.32l1.41-1.41"
        />
      </motion.g>
    </motion.svg>
    <motion.svg
      className="absolute inset-0 text-gray-300 drop-shadow-md mt-1"
      fill="currentColor"
      viewBox="0 0 24 24"
      animate={{ y: [-0.5, 0.5, -0.5] }}
      transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
    >
      <path d="M6.5 17.5a4.5 4.5 0 01-1.23-8.83 7 7 0 1113.46 0 4.5 4.5 0 01-1.23 8.83H6.5z" />
    </motion.svg>
  </div>
);

// 5. Cloudy
const AnimatedCloudy = () => (
  <div className="relative w-5 h-5">
    <motion.svg
      className="absolute inset-0 text-gray-400 drop-shadow-sm -ml-2 -mt-0.5 scale-75"
      fill="currentColor"
      viewBox="0 0 24 24"
      animate={{ x: [-1, 1, -1] }}
      transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
    >
      <path d="M6.5 17.5a4.5 4.5 0 01-1.23-8.83 7 7 0 1113.46 0 4.5 4.5 0 01-1.23 8.83H6.5z" />
    </motion.svg>
    <motion.svg
      className="absolute inset-0 text-gray-200 drop-shadow-md"
      fill="currentColor"
      viewBox="0 0 24 24"
      animate={{ x: [1, -1, 1], y: [-0.5, 0.5, -0.5] }}
      transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
    >
      <path d="M6.5 17.5a4.5 4.5 0 01-1.23-8.83 7 7 0 1113.46 0 4.5 4.5 0 01-1.23 8.83H6.5z" />
    </motion.svg>
  </div>
);

// 6. Windy
const AnimatedWindy = () => (
  <div className="relative w-5 h-5">
    <svg
      className="absolute inset-0 text-gray-300 drop-shadow-md scale-x-110 scale-y-95 -mt-0.5"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path d="M6.5 17.5a4.5 4.5 0 01-1.23-8.83 7 7 0 1113.46 0 4.5 4.5 0 01-1.23 8.83H6.5z" />
    </svg>
    <svg
      className="absolute inset-0 text-blue-200 mt-2"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    >
      <motion.path
        d="M4 16h10a2 2 0 000-4"
        animate={{ x: [-4, 4], opacity: [0, 1, 0] }}
        transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
      />
      <motion.path
        d="M2 20h14a2 2 0 000-4"
        animate={{ x: [-4, 4], opacity: [0, 1, 0] }}
        transition={{
          duration: 1.5,
          delay: 0.5,
          repeat: Infinity,
          ease: "linear",
        }}
      />
    </svg>
  </div>
);

// 7. Fog
const AnimatedFog = () => (
  <div className="relative w-5 h-5">
    <motion.svg
      className="absolute inset-0 text-gray-300 drop-shadow-sm pb-2"
      fill="currentColor"
      viewBox="0 0 24 24"
      animate={{ y: [-1, 1, -1] }}
      transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
    >
      <path d="M6.5 17.5a4.5 4.5 0 01-1.23-8.83 7 7 0 1113.46 0 4.5 4.5 0 01-1.23 8.83H6.5z" />
    </motion.svg>
    <svg
      className="absolute inset-0 text-gray-200 mt-2"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    >
      <motion.line
        x1="6"
        y1="18"
        x2="18"
        y2="18"
        animate={{ x: [-2, 2, -2], opacity: [0.4, 1, 0.4] }}
        transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.line
        x1="4"
        y1="21"
        x2="20"
        y2="21"
        animate={{ x: [2, -2, 2], opacity: [0.4, 1, 0.4] }}
        transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
      />
    </svg>
  </div>
);

// 8. Drizzle
const AnimatedDrizzle = () => (
  <div className="relative w-5 h-5">
    {/* Stretched horizontally and squashed vertically to match the flattened look */}
    <svg
      className="absolute inset-0 text-gray-300 drop-shadow-md scale-x-110 scale-y-75 -mt-1"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path d="M6.5 17.5a4.5 4.5 0 01-1.23-8.83 7 7 0 1113.46 0 4.5 4.5 0 01-1.23 8.83H6.5z" />
    </svg>

    <motion.svg
      className="absolute inset-0 text-blue-300 mt-1"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <motion.circle
        cx="9"
        cy="13" /* Moved up slightly to match the flatter cloud bottom */
        r="1.2"
        animate={{ y: [0, 6], opacity: [1, 0] }}
        transition={{ duration: 1.2, repeat: Infinity, ease: "linear" }}
      />
      <motion.circle
        cx="15"
        cy="13" /* Moved up slightly to match the flatter cloud bottom */
        r="1.2"
        animate={{ y: [0, 6], opacity: [1, 0] }}
        transition={{
          duration: 1.2,
          delay: 0.6,
          repeat: Infinity,
          ease: "linear",
        }}
      />
    </motion.svg>
  </div>
);

// 9. Rain
const AnimatedRain = () => (
  <div className="relative w-5 h-5">
    <svg
      className="absolute inset-0 text-gray-400 drop-shadow-md"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path d="M6.5 17.5a4.5 4.5 0 01-1.23-8.83 7 7 0 1113.46 0 4.5 4.5 0 01-1.23 8.83H6.5z" />
    </svg>
    <motion.svg
      className="absolute inset-0 text-blue-400 mt-1"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="2"
    >
      <motion.line
        x1="8"
        y1="16"
        x2="7"
        y2="20"
        strokeLinecap="round"
        animate={{ y: [0, 5], x: [0, -1], opacity: [1, 0] }}
        transition={{ duration: 0.8, repeat: Infinity, ease: "linear" }}
      />
      <motion.line
        x1="12"
        y1="15"
        x2="11"
        y2="19"
        strokeLinecap="round"
        animate={{ y: [0, 5], x: [0, -1], opacity: [1, 0] }}
        transition={{
          duration: 0.8,
          delay: 0.2,
          repeat: Infinity,
          ease: "linear",
        }}
      />
      <motion.line
        x1="16"
        y1="16"
        x2="15"
        y2="20"
        strokeLinecap="round"
        animate={{ y: [0, 5], x: [0, -1], opacity: [1, 0] }}
        transition={{
          duration: 0.8,
          delay: 0.5,
          repeat: Infinity,
          ease: "linear",
        }}
      />
    </motion.svg>
  </div>
);

// 10. Thunderstorm
const AnimatedThunderstorm = () => (
  <div className="relative w-5 h-5">
    <svg
      className="absolute inset-0 text-gray-400 drop-shadow-md"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path d="M6.5 17.5a4.5 4.5 0 01-1.23-8.83 7 7 0 1113.46 0 4.5 4.5 0 01-1.23 8.83H6.5z" />
    </svg>
    <motion.svg
      className="absolute inset-0 text-yellow-400 mt-1 drop-shadow-md"
      fill="currentColor"
      viewBox="0 0 24 24"
      animate={{ opacity: [0, 1, 0, 1, 0] }}
      transition={{ duration: 2, repeat: Infinity, repeatDelay: 1.5 }}
    >
      <path
        d="M13 10V3L4 14h7v7l9-11h-7z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinejoin="round"
      />
    </motion.svg>
  </div>
);

// 11. Snow
// 11. Snow (Upgraded)
// 11. Snow (Pure Snowflake, No Clouds)
const AnimatedSnow = () => (
  <div className="relative w-5 h-5">
    {/* Slowly rotating central snowflake */}
    <motion.svg
      className="absolute inset-0 text-blue-200 drop-shadow-md scale-95"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <motion.g
        animate={{ rotate: 360 }}
        transition={{ duration: 18, repeat: Infinity, ease: "linear" }}
        style={{ originX: "50%", originY: "50%" }}
      >
        {/* 8-point snowflake geometry */}
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12 3v18m-9-9h18m-15.36-6.36l12.72 12.72m0-12.72L5.64 18.36"
        />
      </motion.g>
    </motion.svg>

    {/* Foreground drifting frost dots to give it depth */}
    <motion.svg
      className="absolute inset-0 text-white/90 drop-shadow-sm"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <motion.circle
        cx="5"
        cy="6"
        r="1.5"
        animate={{ y: [-2, 8], x: [0, -2, 0], opacity: [0, 1, 0] }}
        transition={{ duration: 2.5, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.circle
        cx="19"
        cy="8"
        r="1"
        animate={{ y: [-2, 10], x: [0, 2, -1], opacity: [0, 1, 0] }}
        transition={{
          duration: 3.2,
          delay: 1.2,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />
      <motion.circle
        cx="14"
        cy="16"
        r="1"
        animate={{ y: [0, 6], x: [0, -1, 1], opacity: [0, 1, 0] }}
        transition={{
          duration: 2.8,
          delay: 0.5,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />
    </motion.svg>
  </div>
);

// 11. Snow (Intricate 6-Point Snowflake matching the uploaded image)
const AnimatedSnowGood = () => (
  <div className="relative w-5 h-5">
    {/* Intricate slowly rotating snowflake */}
    <motion.svg
      className="absolute inset-0 text-blue-200 drop-shadow-md scale-90"
      fill="none"
      viewBox="0 0 24 24"
    >
      <motion.g
        animate={{ rotate: 360 }}
        transition={{ duration: 18, repeat: Infinity, ease: "linear" }}
        style={{ originX: "50%", originY: "50%" }}
      >
        {/* Center solid core */}
        <circle cx="12" cy="12" r="2" fill="currentColor" />

        {/* 6 Radiating Arms with double-branches */}
        {[0, 60, 120, 180, 240, 300].map((angle) => (
          <path
            key={angle}
            transform={`rotate(${angle} 12 12)`}
            /* v-9: main stem
              M12 6.5 l-2.5-2.5: left outer branch
              M12 6.5 l2.5-2.5: right outer branch
              M12 9.5 l-1.5-1.5: left inner branch
              M12 9.5 l1.5-1.5: right inner branch
            */
            d="M12 12 v-9 M12 6.5 l-2.5-2.5 M12 6.5 l2.5-2.5 M12 9.5 l-1.5-1.5 M12 9.5 l1.5-1.5"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        ))}
      </motion.g>
    </motion.svg>

    {/* Foreground drifting frost dots for atmospheric depth */}
    <motion.svg
      className="absolute inset-0 text-white/90 drop-shadow-sm"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <motion.circle
        cx="5"
        cy="6"
        r="1.25"
        animate={{ y: [-2, 8], x: [0, -2, 0], opacity: [0, 1, 0] }}
        transition={{ duration: 2.5, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.circle
        cx="19"
        cy="8"
        r="1"
        animate={{ y: [-2, 10], x: [0, 2, -1], opacity: [0, 1, 0] }}
        transition={{
          duration: 3.2,
          delay: 1.2,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />
      <motion.circle
        cx="14"
        cy="16"
        r="1"
        animate={{ y: [0, 6], x: [0, -1, 1], opacity: [0, 1, 0] }}
        transition={{
          duration: 2.8,
          delay: 0.5,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />
    </motion.svg>
  </div>
);

// Main Component
const WeatherIcon = ({ condition }) => {
  // Normalize the condition string just in case your API returns spaces (e.g. "Mostly Clear" -> "MostlyClear")
  const normalizedCondition = condition?.replace(/\s+/g, "") || "Default";

  //   const normalizedCondition = "Snow";

  switch (normalizedCondition) {
    case "Clear":
      return <AnimatedSun />;
    case "MostlyClear":
      return <AnimatedMostlyClear />;
    case "PartlyCloudy":
      return <AnimatedPartlyCloudy />;
    case "MostlyCloudy":
      return <AnimatedMostlyCloudy />;
    case "Cloudy":
      return <AnimatedCloudy />;
    case "Windy":
      return <AnimatedWindy />;
    case "Fog":
      return <AnimatedFog />;
    case "Drizzle":
      return <AnimatedDrizzle />;
    case "Rain":
      return <AnimatedRain />;
    case "Thunderstorm":
      return <AnimatedThunderstorm />;
    case "Snow":
      return <AnimatedSnow />;
    default:
      // Fallback for unknown conditions
      return <AnimatedPartlyCloudy />;
  }
};

export default WeatherIcon;
